<template>
  <section
    class="component-eb152cd5"
    resmed-component-name="info_25/75_icon-line_list_image-readmore-less"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
      'background-size': `${acf.layout['background-size']}`,
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div
          class="row"
          v-bind:class="{
            'align-items-center': acf.layout['align-items-center'] === 'center',
          }"
        >
          <div class="col-md-4 mb-6 mb-md-0">
            <figure>
              <img
                class="img-fluid"
                v-bind:src="acf.image.sizes.large"
                alt=""
              />
            </figure>
          </div>
          <div
            class="col-md-8 pl-md-5"
            v-bind:class="{ 'pt-md-2': acf.eyebrowicon.icon }"
          >
            <eyebrow-icon
              v-if="acf.eyebrowicon.icon"
              v-bind:eyebrowicon="acf.eyebrowicon"
            ></eyebrow-icon>
            <h2
              v-html="acf.headline"
              v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
            ></h2>

            <div v-if="!readmore.active" v-html="acf.excerpt"></div>
            <div v-else v-html="acf.content"></div>

            <div class="read-toggle mt-4">
              <a
                v-on:click.prevent="readmore.active = !readmore.active"
                href="#"
                class="btn cta-pill filled-red icon right-arrow textButtonDark"
                >{{ !readmore.active ? "Read more" : "Read less" }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-eb152cd5", // info_25/75_icon-line_list_image-readmore-less
  props: ["acf"],
  data() {
    return {
      readmore: {
        active: false,
        text: "Read more",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-eb152cd5 {
  padding: 6rem 0;
  overflow: hidden;

  background-position: center center;
  background-repeat: no-repeat;
}

.component {
  h2 {
    position: relative;
    margin-bottom: 1rem;

    &.-has-eyebrow {
      @extend %eyebrow-left;
    }
  }

  figure {
    img {
      margin: 0 auto;
    }

    @media (max-width: 575px) {
      max-width: 320px;
      margin: 0 auto;
    }
  }
}
</style>